import { TableColumn } from '@shared';

export const ACTIVITY_COLUMNS_TAB: TableColumn[] = [
    {
        header: 'Date Created',
        field: 'dateCreated',
        type: 'date',
        hasRedirect: false,
    },
    {
        header: 'Activity',
        field: 'activity',
        type: 'text',
        hasRedirect: false,
    },
];

export const ACTIVITY_DATA_TAB = [
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
    {
        dateCreated: '2026-02-19',
        activity: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
    },
];
